<div class="flex flex-col gap-4 sm:gap-2">
    <!-- Profile Picture & Display Name & Username -->
    <div class="flex flex-row sm:flex-col gap-3 align-middle items-center sm:align-baseline sm:items-start">
        <div class="min-w-28 w-28 min-h-28 h-28 sm:min-w-64 sm:w-64 sm:min-h-64 sm:h-64 bg-center bg-no-repeat rounded-full card-shadow" style="background-size: cover; background-image: url('{{ avatarUrl }}');"></div>
        @if (!isEditing) {
            <div class="flex flex-col">
                <div class="text-lg sm:text-xl">
                    {{ getDisplayName() }}
                </div>
                <div class="text-slate-500 pb-2">
                    {{ user.username }}
                </div>
            </div>
        }
    </div>
    <!-- Misc Info -->
    @if (isEditing) {
        <profile-info-form [user]="user" [profile]="profile"></profile-info-form>
    } @else {
        <div class="flex flex-col gap-1 text-xs sm:text-sm">
            @if (!hasNoRoleBadge) {
                <profile-role-badge [userRole]="userRole"></profile-role-badge>
            }
            @if (!isOwnProfile) {
                <profile-relationship-status [userId]="user.id" [isOwnProfile]="isOwnProfile" [relationship]="relationship"></profile-relationship-status>
            }
            <div class="flex flex-row gap-1 text-slate-500 items-center pl-1">
                <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="calendarSvgIcon" />
                </svg>
                <div>
                    {{ joinedAt }}
                </div>
            </div>
            @if (profile.location) {
                <div class="flex flex-row gap-1 text-slate-500 items-center pl-1">
                    <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                    </svg>
                    <div>
                        {{ profile.location }}
                    </div>
                </div>
            }
            @if (profile.website) {
                <div class="flex flex-row gap-1 text-slate-500 items-center pl-1">
                    <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="linkSvgIcon" />
                    </svg>
                    <div>
                        <a href="{{ profile.website }}" class="hover:text-ponder-linkhover">
                            {{ formatUrl(profile.website) }}
                        </a>
                    </div>
                </div>
            }
            @if (profile.website2) {
                <div class="flex flex-row gap-1 text-slate-500 items-center pl-1">
                    <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="linkSvgIcon" />
                    </svg>
                    <div>
                        <a href="{{ profile.website2 }}" class="hover:text-ponder-linkhover">
                            {{ formatUrl(profile.website2) }}
                        </a>
                    </div>
                </div>
            }
            @if (profile.website3) {
                <div class="flex flex-row gap-1 text-slate-500 items-center pl-1">
                    <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="linkSvgIcon" />
                    </svg>
                    <div>
                        <a href="{{ profile.website3 }}" class="hover:text-ponder-linkhover">
                            {{ formatUrl(profile.website3) }}
                        </a>
                    </div>
                </div>
            }
        </div>
        @if (isOwnProfile) {
            <div class="flex justify-center pt-2">
                <button (click)="onEditClicked()" class="text-sm justify-center w-full flex flex-row items-center gap-1 group bg-slate-50 p-1 min-h-8 rounded-sm shadow-sm stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent">
                    Edit Information
                </button>
            </div>
        }
    }
</div>
